import { types } from 'mobx-state-tree';
import { useStore } from 'mobx-store-provider';
import { Result, ResultSummary } from '../../../shared-components/Exercise/utils.store';
import { isNil } from 'lodash';

const UserAnser = types
  .model('UserAnser', {
    id: types.identifier,
    userAnswer: types.string,
  })
  .actions((self) => ({
    setAnswers(answer: string) {
      self.userAnswer = answer;
    },
  }));

const QuestionInfo = types.model('QuestionInfo', {
  id: types.identifier,
  correctAnswers: types.array(types.string),
});

export const ExerciseShortAnswerDoTestStore = types
  .model('ExerciseShortAnswerStoreDoTest')
  .props({
    id: types.identifier,
    userAnswers: types.map(UserAnser),
    isViewResult: false,
    retryCount: 0,
    questionInfos: types.map(QuestionInfo),
    results: types.map(Result),
    resultSummary: types.maybe(ResultSummary),
  })
  .actions((self) => ({
    setQuestionInfos(infos) {
      self.questionInfos.replace(infos);
    },
    answer({ id, answer }) {
      self.userAnswers.put({ id, userAnswer: answer });
    },
    viewResult() {
      self.isViewResult = true;
    },
    retry() {
      self.retryCount++;
      self.isViewResult = false;
      self.userAnswers.clear();
    },
    setUserAnswers(userAnswers) {
      self.userAnswers.replace(userAnswers);
    },
    check() {
      let correct = 0;
      self.userAnswers.forEach(({ id, userAnswer }) => {
        if (isNil(self.questionInfos)) {
          return;
        }
        const question = self.questionInfos.get(id);
        if (
          (question?.correctAnswers || []).some((ans) => ans === userAnswer.trim().toLowerCase())
        ) {
          correct++;
        }
      });

      self.resultSummary = ResultSummary.create({
        total: self.questionInfos.size,
        correct,
      });
    },
  }))
  .views((self) => ({
    preparePayload() {
      const userAnswers = [];
      self.userAnswers.forEach((answer) => {
        userAnswers.push({ questionId: answer.id, answer: answer.userAnswer });
      });

      return {
        exerciseId: self.id,
        type: 'SHORT_ANSWER',
        isCompleted: self.isViewResult,
        userAnswers,
      };
    },
  }));

export const useExerciseShortAnswerDoTestStore = () => useStore(ExerciseShortAnswerDoTestStore);
